
import $ from 'jquery';
import Parallax from '../vendor/parallax-js';

export default {
  init: (selector) => {
    const $items = $(selector);

    $items.map((i, element) => {
      const parallax = new Parallax(element);
      parallax.friction(0.02, 0.02);

      const $el = $(element);
      const activeClass = $el.data('js-parallax-active-class');

      if (activeClass) {
        $el.addClass(activeClass);
      }
    });
  }
}
